export default __webpack_public_path__ + "static/kurorty-img-8-290cf76c4fca289675c4c056e3444abf.png";